import React, { useEffect, useState, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AccountAdminSideBar from "./AccountAdminSideBar"; 
import { API_URL } from "../../constant";

const AccountAdminLayout = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("account_admin_token");
    navigate("/account-admin/login");
  }, [navigate]);

  const fetchUserData = async () => {
    const token = localStorage.getItem("account_admin_token");
    if (!token) {
      navigate("/account-admin/login");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/account-admin/portal`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error("Invalid or expired token");
      }

      const data = await response.json();
      
      setUserData({
        firstName: data.admin.first_name,
        lastName: data.admin.last_name,
        role: "Account Admin",
        email: data.admin.email,
        id: data.admin.id,
      });
      
    } catch (error) {
      console.error("Error fetching admin data:", error);
      setError(error.message);
      handleLogout();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    marginTop: "0px",
    marginBottom: "0px",
    background: "linear-gradient(to bottom, #ff9800, white)", // Distinctive orange background for admin
    width: "100%",
    minHeight: "100vh",
    fontFamily: "'Poppins', sans-serif"
  };

  if (isLoading) {
    return (
      <div style={{ ...containerStyle, justifyContent: "center", alignItems: "center" }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ ...containerStyle, justifyContent: "center", alignItems: "center" }}>
        <div style={{ color: "red" }}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="pagecontainer1" style={containerStyle}>
      <AccountAdminSideBar 
        user={userData} 
        onLogout={handleLogout}
      />
      <Outlet context={{ userData, fetchUserData, handleLogout }} />
    </div>
  );
};

export default AccountAdminLayout;
